// extracted by mini-css-extract-plugin
export default {"button":"PatientDetailsButton_button__3zzM7"};